module.exports = __webpack_public_path__ + "img/XrU9jladHj.0a6c0663.png";